module.exports = __webpack_public_path__ + "assets/img/left-title-open-b6951ccd.png";